module.exports = __webpack_public_path__ + "img/card-background.baeca92c.jpg";